import { Routes } from '@angular/router';

import { SERVICE_ANALYTICS } from '../shared/models/list';
import { DatacenterComponent } from '../shared/datacenter/datacenter.component';
import {
	DatacenterViewCustomizationComponent
} from '../shared/datacenter/view-customization/datacenter-view-customization.component';
import {
	ProductListViewCustomizationComponent
} from '../shared/components/view-customization/product-list-customization.component';

import { OfferDashboardComponent } from './components/dashboard/offer-dashboard.component';
import { StepHeaderComponent } from './components/wizard/step-header/step-header.component';
import { StepReviewComponent } from './components/wizard/step-review/step-review.component';
import { StepCartComponent } from './components/wizard/step-cart/step-cart.component';
import { StepQuantityComponent } from './components/wizard/step-quantity/step-quantity.component';
import { WizardComponent } from './components/wizard/wizard.component';
import { OfferCardComponent } from './components/cards/offer-card/offer-card.component';
import { OfferLineListComponent } from './components/offer-list/offer-line-list.component';
import { PAGE_NAME_STEPS } from './services/app-wizard.service';
import { wizardEnterGuard } from './guards/wizard-enter.guard';
import { wizardExitGuard } from './guards/wizard-exit.guard';
import { offerListGuard } from './guards/offer-list.guard';
import { offerRoleValidatorGuard } from './guards/offer-role-validator.guard';
import { productFieldNamesTranslationGuard } from './guards/product-field-names-translation.guard';
import { OfferDraftListComponent } from './components/list/offer-draft-list.component';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
		data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.EOFFER }
	},
	{
		path: 'dashboard',
		component: OfferDashboardComponent,
		data: { pageName: 'Offers - Dashboard', service: SERVICE_ANALYTICS.EOFFER }
	},
	{
		path: 'draft',
		component: OfferDraftListComponent,
		canActivate: [offerRoleValidatorGuard],
		data: { pageName: 'Offers - Draft List', service: SERVICE_ANALYTICS.EOFFER }
	},
	{
		path: 'list',
		component: OfferLineListComponent,
		data: { pageName: 'Offers - List', service: SERVICE_ANALYTICS.EOFFER }
	},
	{
		path: 'list/:status',
		component: OfferLineListComponent,
		canActivate: [offerListGuard],
		data: { pageName: 'Offers - List', service: SERVICE_ANALYTICS.EOFFER }
	},
	{
		path: 'datacenter',
		children: [
			{
				path: '',
				component: DatacenterComponent,
				data: {
					pageName: 'Offers - Datacenter',
					service: SERVICE_ANALYTICS.EOFFER,
					type: 'offer',
					title: 'datacenter.offers',
					exportExcelName: 'Offers'
				}
			},
			{
				path: 'view',
				component: DatacenterViewCustomizationComponent,
				data: { pageName: 'Offers - Datacenter Customization', service: SERVICE_ANALYTICS.EOFFER }
			}
		]
	},
	{
		path: 'wizard',
		component: WizardComponent,
		canDeactivate: [wizardExitGuard],
		children: [
			{
				path: '',
				redirectTo: PAGE_NAME_STEPS[0],
				pathMatch: 'full',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.EOFFER }
			},
			{
				path: PAGE_NAME_STEPS[0],
				children: [
					{
						path: '',
						component: StepHeaderComponent,
						canActivate: [wizardEnterGuard, offerRoleValidatorGuard, productFieldNamesTranslationGuard],
						// eslint-disable-next-line @stylistic/max-len
						data: { pageName: 'Offers - Wizard Step 1 (Product Selection)', service: SERVICE_ANALYTICS.EOFFER }
					},
					{
						path: 'view',
						component: ProductListViewCustomizationComponent,
						canActivate: [wizardEnterGuard, productFieldNamesTranslationGuard],
						data: { pageName: 'Offers - Wizard Customization', service: SERVICE_ANALYTICS.WEB_ORDER_ENTRY }
					}
				]
			},
			{
				path: PAGE_NAME_STEPS[1],
				component: StepCartComponent,
				canActivate: [wizardEnterGuard, productFieldNamesTranslationGuard],
				data: { pageName: 'Offers - Wizard Step 2 (Cart)', service: SERVICE_ANALYTICS.EOFFER }
			},
			{
				path: PAGE_NAME_STEPS[2],
				component: StepQuantityComponent,
				canActivate: [wizardEnterGuard, productFieldNamesTranslationGuard],
				data: { pageName: 'Offers - Wizard Step 3 (Quantity)', service: SERVICE_ANALYTICS.EOFFER }
			},
			{
				path: PAGE_NAME_STEPS[3],
				component: StepReviewComponent,
				canActivate: [wizardEnterGuard],
				data: { pageName: 'Offers - Wizard Step 4 (Review)', service: SERVICE_ANALYTICS.EOFFER }
			}
		]
	},
	{
		path: 'card/:offerId',
		component: OfferCardComponent,
		canActivate: [productFieldNamesTranslationGuard],
		data: { pageName: 'Offers - Card', service: SERVICE_ANALYTICS.EOFFER }
	}
];
